import template from './CategoryItemView.html';
import { CategoryItemController } from './CategoryItemController';
export const CategoryItemComponent = {
    require: {
        ngModel: '?ngModel',
    },
    controller: CategoryItemController,
    controllerAs: '$ctrl',
    template,
    bindings: {
        data: '<',
        onDelete: '&?',
        onSave: '&?',
        elementId: '@?',
    },
};
